import { createClient } from '@supabase/supabase-js'
const url = import.meta.env.VITE_SUPABASE_URL as string
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string

if (!url || !key) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY – check .env')
}

export const supabase = createClient(url, key, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
  },
  realtime: { params: { eventsPerSecond: 10 } },
})

// Helper RPC wrappers
export const softDelete   = (table: string, id: string) =>
  supabase.rpc('soft_delete', { p_table: table, p_id: id })

export const generatePin  = () =>
  supabase.rpc('generate_partner_pin')

export const householdSummary = (id: string) =>
  supabase.rpc('get_household_summary', { p_household_id: id })

export const grantReport = (start: string, end: string, county?: string) =>
  supabase.rpc('get_grant_report', { p_start_date: start, p_end_date: end, p_county_id: county ?? null })
